import {combineReducers} from 'redux'
import {CAMPAIGN_LINKS_LOADED, CAMPAIGN_STREAM_LOADED, CAMPAIGN_STREAM_QUERIED, CAMPAIGN_LOADED, CAMPAIGN_QUERIED, ANSWER_STREAM_LOADED, ANSWER_STREAM_QUERIED} from './actions'
import {CREATE_CAMPAIGN_ACTION_UPDATED, ADD_QUESTION_TO_CAMPAIGN_ACTION_UPDATED, UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_UPDATED, UPDATE_TITLE_OF_CAMPAIGN_ACTION_UPDATED, DEFINE_ANSWER_RATE_GOAL_ACTION_UPDATED, START_CAMPAIGN_ACTION_UPDATED, ANSWER_ACTION_UPDATED} from './actions'
import {CREATE_CAMPAIGN_ACTION_SENT, ADD_QUESTION_TO_CAMPAIGN_ACTION_SENT, UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_SENT, UPDATE_TITLE_OF_CAMPAIGN_ACTION_SENT, DEFINE_ANSWER_RATE_GOAL_ACTION_SENT, START_CAMPAIGN_ACTION_SENT, ANSWER_ACTION_SENT} from './actions'

const campaign = (function() {

    function stream(state = [], action) {
        switch (action.type) {
            case CAMPAIGN_STREAM_LOADED:
            case CAMPAIGN_STREAM_QUERIED:
                return action.stream
            default:
                return state
        }
    }

    function _links(state = [], action) {
        switch (action.type) {
            case CAMPAIGN_LINKS_LOADED:
            case CAMPAIGN_STREAM_LOADED:
            case CAMPAIGN_STREAM_QUERIED:
                return action._links
            default:
                return state
        }
    }

    function query(state = null, action) {
        switch (action.type) {
            case CAMPAIGN_STREAM_LOADED:
            case CAMPAIGN_STREAM_QUERIED:
                return action.query
            default:
                return state
        }
    }

    function campaign(state = null, action) {
        switch (action.type) {
            case CAMPAIGN_LOADED:
            case CAMPAIGN_QUERIED:
                return action.campaign
            default:
                return state
        }
    }

    return combineReducers({stream, _links, query, campaign})
})()

const answer = (function() {

    function stream(state = [], action) {
        switch (action.type) {
            case ANSWER_STREAM_LOADED:
            case ANSWER_STREAM_QUERIED:
                return action.stream
            default:
                return state
        }
    }

    function range(state = null, action) {
        switch (action.type) {
            case ANSWER_STREAM_LOADED:
            case ANSWER_STREAM_QUERIED:
                return action.range
            default:
                return state
        }
    }

    function query(state = null, action) {
        switch (action.type) {
            case ANSWER_STREAM_LOADED:
            case ANSWER_STREAM_QUERIED:
                return action.query
            default:
                return state
        }
    }

    return combineReducers({stream, range, query})
})()

function createCampaignAction(state = null, action) {
    switch (action.type) {
        case CREATE_CAMPAIGN_ACTION_UPDATED:
            return {...state, ...action.action}
        case CREATE_CAMPAIGN_ACTION_SENT:
            return null
        default:
            return state
    }
}

function updateNotationScaleOfCampaignAction(state = null, action) {
    switch (action.type) {
        case UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_UPDATED:
            return {...state, ...action.action}
        case UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_SENT:
            return null
        default:
            return state
    }
}

function updateTitleOfCampaignAction(state = null, action) {
    switch (action.type) {
        case UPDATE_TITLE_OF_CAMPAIGN_ACTION_UPDATED:
            return {...state, ...action.action}
        case UPDATE_TITLE_OF_CAMPAIGN_ACTION_SENT:
            return null
        default:
            return state
    }
}

function addQuestionToCampaignAction(state = null, action) {
    switch (action.type) {
        case ADD_QUESTION_TO_CAMPAIGN_ACTION_UPDATED:
            return {...state, ...action.action}
        case ADD_QUESTION_TO_CAMPAIGN_ACTION_SENT:
            return null
        default:
            return state
    }
}

function defineAnswerRateGoalAction(state = null, action) {
    switch (action.type) {
        case DEFINE_ANSWER_RATE_GOAL_ACTION_UPDATED:
            return {...state, ...action.action}
        case DEFINE_ANSWER_RATE_GOAL_ACTION_SENT:
            return null
        default:
            return state
    }
}

function startCampaignAction(state = null, action) {
    switch (action.type) {
        case START_CAMPAIGN_ACTION_UPDATED:
            return {...state, ...action.action}
        case START_CAMPAIGN_ACTION_SENT:
            return null
        default:
            return state
    }
}

function answerAction(state = null, action) {
    switch (action.type) {
        case ANSWER_ACTION_UPDATED:
            return {...state, ...action.action}
        case ANSWER_ACTION_SENT:
            return null
        default:
            return state
    }
}

export default combineReducers({
    answer,
    campaign,
    createCampaignAction,
    updateNotationScaleOfCampaignAction,
    updateTitleOfCampaignAction,
    addQuestionToCampaignAction,
    defineAnswerRateGoalAction,
    startCampaignAction,
    answerAction
})


// WEBPACK FOOTER //
// ./lib/satisfaction/reducers.js